// Period PDF reports (day / month / year) for the monitoring section, built
// with @react-pdf/renderer. The layout lives in ./report/ReportDocument
// (branded header, stat grid, vector chart, breakdown table); this module is
// the thin browser-download entry point.
//
// Contract with MonitoringSection.jsx — do not change the signature:
//   downloadReport(report, tariff, meta) -> downloads a PDF in the browser.
//   report: { kind: "day",   label, day: DayData }
//           { kind: "month", label, year, month, data: MonthData }
//           { kind: "year",  label, year, data: YearData }
//   meta:   { systemKwp, city, installDate, lifetimeKwh, lifetimeCo2Kg } —
//           live values in live mode; mock constants fill in standalone.

import { pdf } from "@react-pdf/renderer";
import { TARIFF_RS_PER_KWH } from "./mockData";
import { registerReportFonts } from "./report/fonts";
import { ReportDocument } from "./report/ReportDocument";
import { saveBlob } from "./report/saveBlob";

export async function downloadReport(report, tariff = TARIFF_RS_PER_KWH, meta = {}) {
  registerReportFonts();
  const blob = await pdf(<ReportDocument report={report} tariff={tariff} meta={meta} />).toBlob();
  const filename = `greentek-solar-report-${report.label.replace(/\s/g, "-")}.pdf`;
  saveBlob(blob, filename);
}
